import type { GetAdminUserSubscriptions200ResponseSubscriptionsItem } from './getAdminUserSubscriptions200ResponseSubscriptionsItem';

export interface GetAdminUserSubscriptions200Response {
  subscriptions?: GetAdminUserSubscriptions200ResponseSubscriptionsItem[];
  success?: boolean;
  userId?: string;
}
